import { useParams, Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ArticleLayout from "../article/components/ArticleLayout";
import { articles } from "@/mocks/articles";

export default function ArticleGuidePage() {
  const { slug } = useParams<{ slug: string }>();
  const article = articles.find((a) => a.slug === slug);

  if (!article) {
    return (
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <div className="pt-24 pb-16 text-center px-4">
          <h1 className="font-heading text-2xl font-semibold text-foreground-950 mb-4">Article Not Found</h1>
          <p className="text-foreground-600 mb-6">The article you are looking for does not exist.</p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-lg font-medium hover:bg-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-home-4-line"></i>
            Back to Home
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <>
      <Navbar />
      <ArticleLayout article={article} />
      <Footer />
    </>
  );
}